import { render, staticRenderFns } from "./ProductEditorDeliveryStatus.vue?vue&type=template&id=173bdff3&"
import script from "./ProductEditorDeliveryStatus.vue?vue&type=script&lang=js&"
export * from "./ProductEditorDeliveryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports